import {without, throttle, debounce} from 'lodash'

// function priorityNav(newsBabNavListEl, newsBarNav) {
//
//     let newsBarNavListElWidth = 0
//
//     newsBabNavListEl.each(function (index) {
//
//         newsBarNavListElWidth += jQuery(this).outerWidth()
//
//         if (newsBarNavListElWidth > newsBarNav.width()) {
//
//             let notVisibleEls = newsBabNavListEl.slice(index - 1)
//
//             jQuery('.news-bar__more ul').append(notVisibleEls)
//
//             return false
//         }
//     })
//
//     if (jQuery('.news-bar__more li').length === 0) {
//         jQuery('.news-bar__more').hide()
//     } else {
//         jQuery('.news-bar__more').show()
//     }
//
// }
//
// jQuery('.news-bar__search button').on('click', function () {
//     jQuery('.news-bar__search form').submit()
// })
//
// let newsBarNav = jQuery('.news-bar__nav'),
//     newsBarNavList = newsBarNav.find('ul'),
//     newsBabNavListEl = newsBarNavList.find('li')
//
// newsBarNavList.prepend('<li class="news-bar__more">More<ul></ul></li>')
//
// priorityNav(newsBabNavListEl, newsBarNav)

let newsSidebar = jQuery('.news__sidebar')

jQuery(window).on('resize', _.debounce(function () {

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }

    //priorityNav(newsBabNavListEl, newsBarNav)

}, 1000))

jQuery(document).ready(function () {

    if (window.matchMedia("(min-width: 1024px)").matches) {
        newsSidebar.appendTo('.news__wrapper')
    } else {
        newsSidebar.prependTo('.news__aside')
    }
})

// const newsPromo = jQuery('.news-promo')
//
// if (newsPromo.length !== 0) {
//
//     const newsPromoCards = jQuery('.news-promo li')
//
//     const min = 1,
//         max = newsPromoCards.length,
//         newsPromoSelectedIndex = Math.floor(min + Math.random() * (max + 1 - min))
//     const newsPromoChosenCard = jQuery(`.news-promo li:eq(${newsPromoSelectedIndex - 1})`)
//     newsPromoChosenCard.show()
//     const adTracked = newsPromoChosenCard.find('div:first')[0]
//     adTracked.className += ' ad-tracking'
//
// }
